import { BackgroungTrazo } from "src/shared/styled/global.styled";

export const BcBackground = () => (<BackgroungTrazo></BackgroungTrazo>)